import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';

type UserProfile = {
  _id: {
    id: string;
  };
  firstName: string;
  lastName: string;
  email: string;
  lastUsedAccountId: {
    id: string;
  };
  profile: {
    id: {
      id: string;
    };
    notificationEmail: {
      id: string;
    };
    imageUrl: string;
  };
  accountIds: [
    {
      id: string;
    },
    {
      id: string;
    },
    {
      id: string;
    }
  ];
  dateCreated: string;
  catalogs: any[];
};

export const getUserProfileById = (userId?: string): Promise<UserProfile> => {
  return cacheableRequest(`/v1/users/${userId}`).then(({ data }: AxiosResponse<UserProfile>) => {
    return data;
  });
};
